import { useContext } from 'react';
import { ServerTimeContext } from '../context/ServerTimeContext';

const useServerTime = () => {
  const context = useContext(ServerTimeContext);
  if (!context) {
    throw new Error('useServerTime must be used within a ServerTimeProvider');
  }
  return context;
};

export default useServerTime;
